import React from 'react';

const Doc = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <title>doc</title>
      <path
        fill="#2b579a"
        d="M19.048 0l-0 3.047 11.429 0c0.806 0 1.467 0.627 1.52 1.419l0.003 0.104v22.857c0 0.806-0.627 1.467-1.419 1.52l-0.104 0.003-11.429-0 0 3.048-19.048-3.337v-25.326l19.048-3.337zM15.238 10.667l-2.202 0.137-1.288 7.482c0 0.099 0 0.198-0.053 0.305-0.043 0.085-0.017 0.166-0.025 0.245l-0.014 0.059 0-0.342c0-0.084 0-0.16-0.038-0.221l-1.47-7.375-2.088 0.13-1.524 7.055c0 0.107-0.046 0.213-0.061 0.32-0.011 0.080-0.006 0.156-0.021 0.234l-0.025 0.079 0-0.602-1.486-6.888-1.897 0.145 2.027 10.21 2.11 0.13 1.44-6.857c0-0.084 0-0.168 0.046-0.267 0.034-0.074 0.017-0.144 0.023-0.216l0.015-0.073 0.001 0.059c0.002 0.074 0.009 0.147 0.037 0.215 0.038 0.091 0 0.183 0.046 0.274l1.455 7.025 2.286 0.137 2.705-11.398zM19.048 10.667h8.381v1.524h-8.381v1.524h8.381v1.524h-8.381v1.524h8.381v1.524h-8.381v1.524h8.381v1.524h-8.381v1.524h8.381v1.524h-8.381l-0 3.047 11.429 0.001v-22.857l-11.429-0 0 3.048h8.381v1.524h-8.381v1.524z"
      ></path>
    </svg>
  );
};

export default Doc;
